import React from 'react'
import classNames from 'classnames'

interface RadioProps {
  children: React.ReactNode
  value: string
  currentValue: string
  onChange: any
  name: string
  centerLabel?: boolean
  buttonAlignment?: 'left' | 'right' | 'top-left' | 'top-right'
}

interface RadioGroupProps {
  children: React.ReactNode
  stack?: boolean
}

export const Radio = ({
  name,
  children,
  value,
  currentValue,
  onChange,
  centerLabel = false,
  buttonAlignment = 'left',
}: RadioProps) => {
  return (
    <div className={'radio-button'}>
      <label
        className={classNames({ 'radio-checked': value === currentValue }, { center: centerLabel })}
      >
        <input
          className={buttonAlignment}
          type='radio'
          name={name}
          id={name}
          value={value}
          checked={value === currentValue}
          onChange={onChange}
        />
        {children}
      </label>
    </div>
  )
}

interface CriticalRadioProps {
  name: string
  checked: boolean
  children?: React.ReactNode
  centerLabel?: boolean
  buttonAlignment?: 'left' | 'right' | 'top-left' | 'top-right'
  labelTarget: Record<string, string>
  buttonActions: Record<string, string | number>
  onClick?: any
}

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

export const CriticalRadio = ({
  name,
  checked,
  children,
  centerLabel = false,
  buttonAlignment = 'left',
  labelTarget,
  buttonActions,
  onClick = () => {},
}: CriticalRadioProps) => {
  return (
    <div onClick={onClick} className={'radio-button'}>
      <label
        className={classNames({ 'radio-checked': checked }, { center: centerLabel })}
        {...labelTarget}
      >
        <input
          className={buttonAlignment}
          type='radio'
          name={name}
          readOnly={true}
          checked={checked}
          {...buttonActions}
        />
        {children}
      </label>
    </div>
  )
}

const RadioGroup = ({ children, stack = false }: RadioGroupProps) => (
  <div className={classNames({ 'radio-group': true }, { 'radio-group__stack': stack })}>
    {children}
  </div>
)

export default RadioGroup
